import {createFetchListReducer} from 'common/reducers/utils';

const defaultReducer = createFetchListReducer({
  name: 'agency address',
  pluralName: 'agency addresses',
  keys: ['agencyId'],
});

export default function agencyAddresses(state = {
  isFetching: false,
  items: null,
  agencyId: null,
}, action) {
  return defaultReducer(state, action);
}



// WEBPACK FOOTER //
// ./src/ondemand/reducers/agencyAddress.js